module.exports = __webpack_public_path__ + "assets/img/mecha-3ccb780f.png";